// Ajout des icônes d'informations complémentaires aux attributs de produits

import $ from 'jquery';

// Finition
let fileFinition = $('#pa_finition').parent().siblings('td');
fileFinition.append('<a class="complementary-informations pa_finition"></a>');
$('.pa_finition').attr('href',complementaryFiles.finition.url);
// Couleur 
let fileColor = $('.tawcvs-swatches').parent().siblings('td');
fileColor.append('<a class="complementary-informations pa_color"></a>');
$('.pa_color').attr('href', complementaryFiles.color.url);

// Gestion de l'eau
let waterManagement = $('#pa_gestion-de-leau').parent().siblings('td');
waterManagement.append('<a class="complementary-informations pa_water_management"></a>');
$('.pa_water_management').attr('href', complementaryFiles.water_management.url);


 // Setting colorbox settings
let cboxOptions = {
    width: '95%',
    height: '95%',
    iframe: true,
    maxWidth: '960px',
    maxHeight: '960px',
}
 // Fonction permettant de resize colorbox 
$(window).on('resize', function() {
    if(colorbox) {
    // const $cBoxEl = $.colorbox.element();
        $.colorbox.resize({
            width: window.innerWidth > parseInt(cboxOptions.maxWidth) ? cboxOptions.maxWidth : cboxOptions.width,
            height: window.innerHeight > parseInt(cboxOptions.maxHeight) ? cboxOptions.maxHeight : cboxOptions.height
        }); 
    }
});

$('.pa_finition').colorbox(cboxOptions);
$('.pa_color').colorbox(cboxOptions);
$('.pa_water_management').colorbox(cboxOptions);

